import { render, staticRenderFns } from "./SingleUrl.vue?vue&type=template&id=d74a417e&scoped=true&"
import script from "./SingleUrl.vue?vue&type=script&lang=js&"
export * from "./SingleUrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d74a417e",
  null
  
)

export default component.exports